import { ILaya } from "../../ILaya";
import { LayaEnv } from "../../LayaEnv";
import { NodeFlags } from "../Const";
import { Event } from "../events/Event";
import { SerializeUtil } from "../loaders/SerializeUtil";
import { MathUtil } from "../maths/MathUtil";
import { Point } from "../maths/Point";
import { ProgressTitleType } from "./Const";
import { GWidget } from "./GWidget";
export class GSlider extends GWidget {
    constructor() {
        super();
        this.changeOnClick = true;
        this.canDrag = true;
        this._min = 0;
        this._max = 0;
        this._value = 0;
        this._titleType = 0;
        this._reverse = false;
        this._wholeNumbers = false;
        this._barMaxWidthDelta = 0;
        this._barMaxHeightDelta = 0;
        this._clickPercent = 0;
        this._barStartX = 0;
        this._barStartY = 0;
        this._value = 50;
        this._max = 100;
        this._clickPos = new Point();
        this.on(Event.MOUSE_DOWN, this, this._barTouchBegin);
    }
    get titleType() {
        return this._titleType;
    }
    set titleType(value) {
        if (this._titleType != value) {
            this._titleType = value;
            this.update(true);
        }
    }
    get wholeNumbers() {
        return this._wholeNumbers;
    }
    set wholeNumbers(value) {
        if (this._wholeNumbers != value) {
            this._wholeNumbers = value;
            this.update(true);
        }
    }
    get min() {
        return this._min;
    }
    set min(value) {
        if (this._min != value) {
            this._min = value;
            this.update(true);
        }
    }
    get max() {
        return this._max;
    }
    set max(value) {
        if (this._max != value) {
            this._max = value;
            this.update(true);
        }
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value != value) {
            this._value = value;
            this.update(true);
        }
    }
    get hBar() {
        return this._hBar;
    }
    set hBar(value) {
        this._hBar = value;
        this._value = this._max;
        this._barStartX = 0;
        this.update(false);
    }
    get vBar() {
        return this._vBar;
    }
    set vBar(value) {
        this._vBar = value;
        this._value = this._max;
        this._barStartY = 0;
        this.update(false);
    }
    get gripButton() {
        return this._gripButton;
    }
    set gripButton(value) {
        this.setupEvents(false);
        this._gripButton = value;
        this.setupEvents(true);
    }
    get titleWidget() {
        return this._titleWidget;
    }
    set titleWidget(value) {
        this._titleWidget = value;
        this.update(false);
    }
    get reverse() {
        return this._reverse;
    }
    set reverse(value) {
        this._reverse = value;
        this.update(false);
    }
    update(delay) {
        if (delay === true)
            ILaya.timer.callLater(this, this.update);
        else
            this.updateWithPercent((this._value - this._min) / (this._max - this._min), false);
    }
    updateWithPercent(percent, manual) {
        if (this._getBit(NodeFlags.EDITING_ROOT_NODE)) {
            this.updateTitle(this._max, this._max, 1);
            return;
        }
        percent = MathUtil.clamp01(percent);
        if (manual) {
            let newValue = MathUtil.clamp(this._min + (this._max - this._min) * percent, this._min, this._max);
            if (this._wholeNumbers) {
                newValue = Math.round(newValue);
                percent = MathUtil.clamp01((newValue - this._min) / (this._max - this._min));
            }
            if (newValue != this._value) {
                this._value = newValue;
                this.event(Event.CHANGED, Event.EMPTY);
                if (!this.canDrag)
                    return;
            }
        }
        this.updateTitle(this._value, this._max, percent);
        let fullWidth = this.width - this._barMaxWidthDelta;
        let fullHeight = this.height - this._barMaxHeightDelta;
        if (!this._reverse) {
            if (this._hBar)
                this._hBar.width = Math.round(fullWidth * percent);
            if (this._vBar)
                this._vBar.height = Math.round(fullHeight * percent);
        }
        else {
            if (this._hBar) {
                this._hBar.width = Math.round(fullWidth * percent);
                this._hBar.x = this._barStartX + (fullWidth - this._hBar.width);
            }
            if (this._vBar) {
                this._vBar.height = Math.round(fullHeight * percent);
                this._vBar.y = this._barStartY + (fullHeight - this._vBar.height);
            }
        }
    }
    updateTitle(value, max, percent) {
        let obj = this._titleWidget;
        if (!obj)
            return;
        switch (this._titleType) {
            case ProgressTitleType.Percent:
                obj.text = Math.floor(percent * 100) + "%";
                break;
            case ProgressTitleType.ValueAndMax:
                obj.text = Math.floor(value) + "/" + Math.floor(max);
                break;
            case ProgressTitleType.Value:
                obj.text = "" + Math.floor(value);
                break;
            case ProgressTitleType.Max:
                obj.text = "" + Math.floor(max);
                break;
        }
    }
    _onConstruct(inPrefab) {
        if (this._hBar) {
            this._barMaxWidthDelta = this.width - this._hBar.width;
            this._barStartX = this._hBar.x;
        }
        if (this._vBar) {
            this._barMaxHeightDelta = this.height - this._vBar.height;
            this._barStartY = this._vBar.y;
        }
        this.setupEvents(true);
        ILaya.timer.runCallLater(this, this.update, true);
        super._onConstruct(inPrefab);
    }
    setupEvents(add) {
        if (!LayaEnv.isPlaying)
            return;
        if (this._gripButton) {
            if (add) {
                this._gripButton.on(Event.MOUSE_DOWN, this, this._gripTouchBegin);
                this._gripButton.on(Event.MOUSE_DRAG, this, this._gripTouchMove);
            }
            else {
                this._gripButton.off(Event.MOUSE_DOWN, this, this._gripTouchBegin);
                this._gripButton.off(Event.MOUSE_DRAG, this, this._gripTouchMove);
            }
        }
    }
    _sizeChanged() {
        super._sizeChanged();
        this.update(true);
    }
    _gripTouchBegin(evt) {
        if (evt.button != 0)
            return;
        this.canDrag = true;
        evt.stopPropagation();
        this.globalToLocal(this._clickPos.copy(evt.touchPos));
        this._clickPercent = MathUtil.clamp01((this._value - this._min) / (this._max - this._min));
    }
    _gripTouchMove(evt) {
        if (!this.canDrag)
            return;
        let pt = this.globalToLocal(s_vec2.copy(evt.touchPos));
        let deltaX = pt.x - this._clickPos.x;
        let deltaY = pt.y - this._clickPos.y;
        if (this._reverse) {
            deltaX = -deltaX;
            deltaY = -deltaY;
        }
        let percent;
        if (this._hBar)
            percent = this._clickPercent + deltaX / (this.width - this._barMaxWidthDelta);
        else
            percent = this._clickPercent + deltaY / (this.height - this._barMaxHeightDelta);
        this.updateWithPercent(percent, true);
    }
    _barTouchBegin(evt) {
        if (!this.changeOnClick)
            return;
        let pt = this._gripButton.globalToLocal(s_vec2.copy(evt.touchPos));
        let percent = MathUtil.clamp01((this._value - this._min) / (this._max - this._min));
        let delta = 0;
        if (this._hBar)
            delta = (pt.x - this._gripButton.width / 2) / (this.width - this._barMaxWidthDelta);
        if (this._vBar)
            delta = (pt.y - this._gripButton.height / 2) / (this.height - this._barMaxHeightDelta);
        if (this._reverse)
            percent -= delta;
        else
            percent += delta;
        this.updateWithPercent(percent, true);
    }
    onAfterDeserialize() {
        if (SerializeUtil.hasProp("_gripButton"))
            this.setupEvents(true);
    }
}
const s_vec2 = new Point();
